import { makeStyles } from '@material-ui/core';
import { FC, ChangeEvent } from 'react';
import CButton from 'src/component/Button';
import { CStandardInput } from 'src/component/Input';

const useStyle = makeStyles({
  inputRow: {
    '& > *:nth-child(1)': {
      flex: 'auto'
    },
    alignItems: 'center',
    display: 'flex',
    marginTop: '8px',
    width: '100%'
  },
  root: {
    ' & .MuiInputBase-root': {
      border: '1px solid #CAD8FF',
      borderRadius: '12px',
      color: 'black',
      padding: '14px 16px'
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: '#9BA0AD'
    },
    '& .MuiInput-inputMultiline': {
      alignItems: 'flex-start',
      height: '110px'
    },
    '& .MuiInput-underline:before': {
      display: 'none'
    },
    '& .MuiInputBase-input': {
      fontSize: '12px',
      padding: '0px'
    },
    '& .MuiInputLabel-formControl': {
      fontSize: '12px',
      left: '10px',
      top: '8px'
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(-10px, -10px) scale(0.83)'
    }
  }
});

const infoBarStyle = {
  fontFamily: 'poppins',
  fontSize: '12px',
  lineHeight: '20px',
  marginBottom: '6px'
};

interface ModalInputGroupProps {
  anchorHref?: string;
  anchorText?: string;
  buttonText?: string;
  description?: string;
  disabled?: boolean;
  error?: string;
  htmlFor: string;
  label: string;
  onButtonClick?: () => void;
  onChange: (value: string) => void;
  value: string;
}

const ModalInputGroup: FC<ModalInputGroupProps> = ({
  anchorHref,
  anchorText,
  buttonText,
  description,
  disabled,
  error,
  htmlFor,
  label,
  onButtonClick,
  onChange,
  value
}) => {
  const classes = useStyle();

  return (
    <>
      <div className={classes.inputRow}>
        <CStandardInput
          disabled={disabled}
          disableUnderline
          formclasses={{ root: classes.root }}
          htmlFor={htmlFor}
          id={htmlFor}
          label={label}
          onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
          size="large"
          value={value}
        />

        {buttonText && onButtonClick ? (
          <CButton
            htmlType="button"
            onClick={onButtonClick}
            type="primary"
            xstyle={{ borderRadius: '12px', marginTop: '16px' }}
          >
            {buttonText}
          </CButton>
        ) : null}
      </div>

      {description ? (
        <p style={infoBarStyle}>
          {description}{' '}
          {anchorText && anchorHref && (
            <a href={anchorHref} rel="noreferrer" target="_blank">
              {anchorText}
            </a>
          )}
        </p>
      ) : null}

      {error ? <p style={{ ...infoBarStyle, color: 'red' }}>{error}</p> : null}
    </>
  );
};

export default ModalInputGroup;
